export default "__VITE_ASSET__EQUVjOoU__"